import { render, staticRenderFns } from "./ResellerServiceForm.vue?vue&type=template&id=4c8950ec&"
import script from "./ResellerServiceForm.vue?vue&type=script&lang=js&"
export * from "./ResellerServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports